// @flow

/**
 * Module dependencies.
 */

import { Link } from 'react-router-dom';
import { List, ListItem } from 'client/components/core/lists';
import { branch } from 'core/utils';
import { colors, defaultTransition, media, states, units } from 'client/styles';
import { getLocalizedUrl, isLocalizedUrlActive } from 'client/core/utils';
import { ifProp } from 'styled-tools';
import { position, size } from 'polished';
import { withRouter } from 'react-router';
import React from 'react';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  fixed: boolean,
  links: Array<Object>,
  location: Object
};

/**
 * `Item` component.
 */

const Item = styled(ListItem)`
  margin: 0 ${units(0.25)};

  ${media.min.lg`
    margin: 0 ${units(1)};
  `};
`;

/**
 * `LinkItem` component.
 */

const LinkItem = styled(Link)`
  color: ${colors.white};
  display: block;
  margin-top: 18px;
  padding: ${units(1)};
  position: relative;
  transition: color ${defaultTransition};

  ${states.action`
    text-decoration: none;
  `};

  &:before {
    ${position('absolute', '-18px', '0', null, '0')};
    ${size('4px', '100%')};

    background-color: ${colors.brandPrimary};
    content: '';
    transform-origin: center;
    transform: scaleX(${ifProp('isActive', 1, 0)});
    transition: transform ${defaultTransition};
  }

  &.sticky {
    color: ${colors.brandSecondary};
  }

  ${states.interaction`
    color: ${colors.brandPrimary};

    &:before {
      transform: scaleX(1);
    }
  `};
`;

/**
 * `MenuMain` component.
 */

function MenuMain(props: Props): React$Element<*> {
  const { fixed, links, location } = props;

  return (
    <List>
      {links.map(({ key, title }: Object): React$Element<*> => {
        const isActive = isLocalizedUrlActive(key, location.pathname);

        return (
          <Item key={title}>
            <LinkItem
              className={`${branch(fixed, 'sticky')} ${branch(isActive, 'active')}`}
              to={getLocalizedUrl(key)}
            >
              {title}
            </LinkItem>
          </Item>
        );
      })}
    </List>
  );
}

/**
 * Export `MenuMain`.
 */

export default withRouter(MenuMain);



// WEBPACK FOOTER //
// ../src/client/components/navbar/menu-main.js